import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../core/services/cra-esn/cra-esn.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import {
  serverError,
  successAddworkfloww,
} from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-workflow-cra',
  templateUrl: './workflow-cra.component.html',
  styleUrls: ['./workflow-cra.component.css'],
})
export class WorkflowCraComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  company_id: any;
  name = [
    { id: 1, name: 'Consultant' },
    { id: 2, name: 'Responsable' },
    { id: 3, name: 'RH' },
  ];
  state = [
    { id: 1, name: 'Validé' },
    { id: 2, name: 'Rejeté' },
  ];
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
  }
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      company_id: [this.localStorageService.getData('clientConnected')],
      company_id_specific: [data?.company_id_specific || ''],
      consultant_id: [data?.consultant_id || ''],
      state_workflow: ['1'],
      subWorkFlows: this.formBuilder.array(
        Array.isArray(data?.subWorkFlows) && data?.subWorkFlows.length
          ? data.subWorkFlows.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()]
      ),
    });
  }
  createFormssubWorkFlows(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : null],
      state: [data ? data.state : null],
      custom_role_id: [data ? data.custom_role_id : ''],
      step: '1',
    });
  }

  /* create workflow general*/
  createWorkflow() {
    this.spinner.show();
    this.serviceCraEsn
      .createWorkFlowForm(this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', this.formWorkFlow.value);
          this.spinner.hide();

          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          // this.closeModal()
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              // Swal.fire(this.toastMessages.error);
              // this.toastr.error(this.toastMessages.error);
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  addsubWorkFlows() {
    const subWork = this.formWorkFlow.get('subWorkFlows') as FormArray;
    subWork.push(this.createFormssubWorkFlows());
  }
  get subWorkFlowsControls(): AbstractControl<any, any>[] {
    return (this.formWorkFlow.get('subWorkFlows') as FormArray)?.controls || [];
  }
  ResetForm() {
    this.formWorkFlow.reset();
    // this.modalRef!.hide();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
